import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';
import { buildWalletsGroup } from '../../_shared/images/wallets-group';

export const macroBeneficios1080x1920A: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),
    {
      rx: 10,
      ry: 10,
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 960,
      width: 150,
      height: 100,
      fill: 'rgb(255,255,255)',
      stroke: '#1e40af',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 6.1669,
      scaleY: 7.0044,
      angle: -89.7821,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildPillPair({
      left: { pieceId: 'category', text: 'GASTRONOMÍA', style: 'white-blue-stroke' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'pink-white-text' },
      fontSize: 35,
      paddingX: 21.882,
      paddingY: 7.294,
      strokeWidth: 1.824,
      position: { left: 540, top: 383.1688, width: 632.4051, height: 54.7686 }
    }),
    buildLimitText({
      pieceId: 'limit-text',
      text: 'Tope $10.000 por cliente, por semana.',
      position: { left: 540, top: 1351.2598, width: 595, height: 31.64 }
    }),
    {
      fontSize: 77,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 801.9713,
      top: 611.4678,
      width: 97.7724,
      height: 87.01,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    // vertical
    {
      rx: 0,
      ry: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1317.4533,
      width: 150,
      height: 100,
      fill: 'rgb(0,48,235)',
      stroke: '#1e40af',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 4.668,
      scaleY: 0.02,
      angle: 0,
      flipX: false,
      flipY: true,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    // payment-method-highlight pieces live in the polymorphic binding (see beneficios/index.ts).
    buildPaymentMethodText({
      pieceId: 'payment-method-text',
      text: 'Con todas tus Tarjetas de Crédito Macro',
      fontSize: 32,
      lineHeight: 0.96,
      textAlign: 'left',
      position: { left: 711.3508, top: 1066.9139, width: 325.9244, height: 105.5872 },
      attachTo: { pieceId: 'horizontal-divider', side: 'right', gap: 16 },
      linkedAcrossResolutions: false
    }),
    buildDiscountValue({
      pieceId: 'discount-value',
      text: '20',
      fontSize: 493,
      position: { left: 540, top: 800.3136, width: 604.8935, height: 557.09 }
    }),

    // horizontal
    {
      pieceId: 'horizontal-divider',
      attachTo: { pieceId: 'installments-suffix', side: 'right', gap: 16 },
      rx: 0,
      ry: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 525.1086,
      top: 1068.795,
      width: 150,
      height: 100,
      fill: 'rgb(0,48,235)',
      stroke: '#1e40af',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.02,
      scaleY: 1.1573,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 25,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'Hasta',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      pieceId: 'hasta-label',
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270.728,
      top: 1063.6234,
      width: 70.8756,
      height: 28.25,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildBenefitLabel({
      pieceId: 'benefit-label',
      text: 'de ahorro',
      fontSize: 31,
      position: { left: 773.5784, top: 742.4457 },
      borderRadius: 31
    }),
    {
      fontSize: 131,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '6',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      pieceId: 'installments-value',
      attachTo: { pieceId: 'hasta-label', side: 'right', gap: 12 },
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 372.6993,
      top: 1069.9633,
      width: 83.0359,
      height: 148.03,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 28,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 0.76,
      text: 'cuotas sin interés',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      pieceId: 'installments-suffix',
      attachTo: { pieceId: 'installments-value', side: 'right', gap: 12 },
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 463.4779,
      top: 1067.1211,
      width: 96.5524,
      height: 79.7328,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    {
      cropX: 0,
      cropY: 0,
      pieceId: 'brand-logo',
      imageFit: 'contain',
      imageBox: {
        width: 176,
        height: 176
      },
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1588.4237,
      width: 400,
      height: 400,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.44,
      scaleY: 0.44,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: '',
      crossOrigin: null,
      filters: []
    },

    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 540, top: 1750.0427, width: 683, height: 30.51 }
    }),

    // wallet slots group
    buildWalletsGroup({ position: { left: 540, top: 1261.4826, height: 50 } })
  ],
  background: '#fff',
  clipPath: {
    rx: 0,
    ry: 0,
    selectable: true,
    evented: true,
    lockMovementX: false,
    lockMovementY: false,
    lockScalingX: false,
    lockScalingY: false,
    lockRotation: false,
    objectCaching: true,
    type: 'Rect',
    version: '7.1.0',
    originX: 'left',
    originY: 'top',
    left: 0,
    top: 0,
    width: 1080,
    height: 1920,
    fill: 'rgb(0,0,0)',
    stroke: null,
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: false,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }
};
